import { useState } from 'react'
import { Typography, TypographyProps, Tooltip } from '@mui/material'
import { useUpdateDocument } from '@/service-library/hooks/documents'
import { Document } from '@/types/documents'
import EditableNameField from '@/components/editable-name/EditableNameField'

type EditableDocumentNameProps = {
  document: Document
  updateDocumentAsync: ReturnType<
    typeof useUpdateDocument
  >['updateDocumentAsync']
  disabled?: boolean
  typographyProps?: TypographyProps
  onChange?: (updatedDocument: Document) => void
}

export default function EditableDocumentName({
  document,
  updateDocumentAsync,
  disabled,
  typographyProps,
  onChange,
}: EditableDocumentNameProps) {
  const [isEditing, setIsEditing] = useState(false)

  function handleOnBlur(name: string) {
    setIsEditing(false)
    if (name && name !== document.name) {
      const updatedDocument = {
        ...document,
        name,
      }
      updateDocumentAsync(updatedDocument)
        .then(() => {
          onChange?.(updatedDocument)
        })
        .catch(() => {})
    }
  }
  const docName = document?.name

  return isEditing ? (
    <EditableNameField name={docName} handleOnBlur={handleOnBlur} />
  ) : (
    <Tooltip
      title={disabled ? '' : 'Click to edit name'}
      arrow
      enterDelay={1000}
    >
      <Typography
        sx={{ pr: 1, cursor: disabled ? 'default' : 'pointer' }}
        tabIndex={0}
        {...typographyProps}
        onClick={() => !disabled && setIsEditing(true)}
        onFocus={() => !disabled && setIsEditing(true)}
        noWrap
      >
        {docName}
      </Typography>
    </Tooltip>
  )
}
